module.exports = __webpack_public_path__ + "img/0-02-0a-3bbbb47cd10420ee9a3d20365a013d78ff4db70e91e326cd2feb997c80fb3400_e79c3d91.b19cbad1.jpg";